import { render, staticRenderFns } from "./Page12.vue?vue&type=template&id=c0c82714&scoped=true&"
import script from "./Page12.vue?vue&type=script&lang=ts&"
export * from "./Page12.vue?vue&type=script&lang=ts&"
import style0 from "./Page12.vue?vue&type=style&index=0&id=c0c82714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c82714",
  null
  
)

export default component.exports